import React from 'react'
import { HomePage } from '../components/landingPage/HomePage'

export const LandingPage = () => {
  return (
    <HomePage/>
  )
}
